// extracted by mini-css-extract-plugin
export default {"assignedLocationsCellsWrapper":"AssignedLocationsTable_assignedLocationsCellsWrapper__n0UlV"};